import React, { Component } from "react";
import { connect } from 'react-redux';
import "./App.css";
import Routes from "./routes/index";
import { Loading } from '@/components/Loading';

@connect(
  state => state.base
)
class App extends Component {
  render() {
    return (
      <div className="container">
        {this.props.loading && <div className="screen-loading">
          <Loading />
        </div>}
        <Routes></Routes>
      </div>
    );
  }
}

export default App;
